import { getRSABase64PublicKey } from '@/apis/index'
import store from '@/store'
import JSEncrypt from 'jsencrypt'

// 存取sessionStorage中的数据
function getItem(key) {
  let value = sessionStorage.getItem(key)
  return typeof value === 'string' ? value : JSON.parse(value)
}
function setItem(key, value) {
  sessionStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value))
}

async function rsaEncryptCode(params) {
  let RSABase64PublicKey = ''
  let rsaPubKey = getItem('rsaPubKey')
  try {
    if (rsaPubKey) {
      RSABase64PublicKey = rsaPubKey
    } else {
      let res = await getRSABase64PublicKey()
      RSABase64PublicKey = `
      -----BEGIN PUBLIC KEY-----
      ${res.data}
      -----END PUBLIC KEY-----`
      setItem('rsaPubKey', RSABase64PublicKey)
    }
    const jsencrypt = new JSEncrypt()
    jsencrypt.setPublicKey(RSABase64PublicKey)
    let strParam = encodeURIComponent(JSON.stringify(params))
    let len = Math.ceil(strParam.length / 100)
    let emptyArr = []
    for (let i = 0; i < len; i++) {
      let j = i * 100
      emptyArr.push(strParam.slice(j, j + 100))
    }
    let newArr = []
    emptyArr.forEach((item) => {
      newArr.push(jsencrypt.encrypt(item))
    })
    return newArr.join(',')
  } catch (e) {
    console.log('e :>> ', e)
  }
}

export { rsaEncryptCode }
